export * from "./ToteBetsApiPlaceBetRequest";
//# sourceMappingURL=index.js.map